import sortPrices from './sortedprices';
import {sectionRowsToBlockingCodes} from './blocking_code';
import intersection from 'lodash/intersection';
import objectValues from 'lodash/values';

const validPriceTypesBasedOnBlockingCodes = (priceTypes, blockingCodes) => {
  return objectValues(priceTypes).filter(priceType => {
    //  blocking code 0 means that we want to show the regular price types,
    //  so we include the price types without codes
    const blockingCodeIsZero = priceType.blockingCodes.length === 0 && blockingCodes.indexOf(0) !== -1;
    const hasMatchingCode = intersection(priceType.blockingCodes, blockingCodes).length > 0;
    return hasMatchingCode || blockingCodeIsZero;
  });
};

export default (section, priceTypes, prices) => {
  const blockingCodes = sectionRowsToBlockingCodes(section.rows);
  const validPriceTypes = validPriceTypesBasedOnBlockingCodes(priceTypes, blockingCodes);
  const priceTypeIds = validPriceTypes.map(priceType => priceType.number);
  const validPrices = prices.filter(price => priceTypeIds.indexOf(parseInt(price.priceType)) !== -1);
  return sortPrices(validPrices, priceTypes);
};



// WEBPACK FOOTER //
// ./frontend/react/utils/sim/prices_for_section.js